<!-- profile card -->
<div class="w-full  bg-white rounded-lg border sticky top-5 overflow-hidden">

    <!-- profile -->
    <div class="p-5">

        <div class="flex justify-end">
            <button class="btn btn-circle btn-light" type="button" (click)="openEditModal()"><i class="ri-edit-line"></i></button>
        </div>

        <div class="avatar flex justify-center">
            <div class="w-28 rounded-full">
                <img src={{profileData?.profile_photo}} />
            </div>
        </div>
        <h2 class="text-center mt-2 font-medium text-lg">
            {{profileData?.first_name}} {{profileData?.last_name}}
        </h2>
        <p class="text-zinc-500 text-sm text-center mt-2">{{profileData?.mobile}}</p>
        <p class="text-zinc-500 text-sm text-center">{{profileData?.email || profileData?.email_id}}</p>


        <div class="mt-3 hidden flex flex-col gap-2 items-center">
            <div class="flex justify-between items-center bg-zinc-100 p-2 rounded-lg min-w-[15rem]">
                <a class="flex items-center gap-2">
                    <i class="ri-phone-fill text-zinc-500"></i>
                    <span class="">{{profileData?.mobile}}</span>
                </a>
                <button class="btn btn-xs"><i class="ri-file-copy-line"></i></button>

            </div>

            <div class="flex justify-between items-center bg-zinc-100 p-2 rounded-lg min-w-[15rem]">
                <a class="flex items-center gap-2">
                    <i class="ri-mail-line text-zinc-500"></i>
                    <span class="">{{profileData?.email_id}}</span>
                </a>
                <button class="btn btn-xs"><i class="ri-file-copy-line"></i></button>
            </div>

        </div>



    </div>
    <hr>
    <!-- profile -->
    @if (profileData) {
    <!-- personal Details -->
    <div class="collapse collapse-arrow  border-b rounded-none">
        <input type="checkbox" />
        <div class="collapse-title text-sm uppercase font-semibold ">Personal Details</div>
        <div class="collapse-content border-t">
            <ul class="flex flex-col gap-2 mt-3">
                <li class="text-sm flex px-2"><span class="font-semibold">Role :</span><span
                        class="text-zinc-500">{{profileData?.role?.name || profileData?.role?.alias || profileData?.role_id || '-'}}</span></li>
                <li class="text-sm flex px-2"><span class="font-semibold">Date of Birth :</span><span
                        class="text-zinc-500">{{profileData?.date_of_birth ? ('' + profileData.date_of_birth) : '-'}}</span></li>

                @if (profileData?.admission) {
                <li class="text-sm flex px-2"><span class="font-semibold">Class :</span><span
                        class="text-zinc-500">{{profileData?.admission?.class?.class_name || '-'}}</span></li>
                <li class="text-sm flex px-2"><span class="font-semibold">Batch :</span><span
                        class="text-zinc-500">{{profileData?.admission?.batch?.batch_name || '-'}}</span></li>
                <li class="text-sm flex px-2"><span class="font-semibold">Department :</span><span
                        class="text-zinc-500">{{profileData?.admission?.department?.department_name || '-'}}</span></li>
                } @else {
                <li class="text-sm flex px-2"><span class="font-semibold">Department :</span><span
                        class="text-zinc-500">{{profileData?.department_id || '-'}}</span></li>
                }


            </ul>
        </div>
    </div>
    <!-- personal Details -->
    }
    @if (isStudent && profileData?.parent_details) {
    <div class="collapse collapse-arrow border-b rounded-none">
        <input type="checkbox" />
        <div class="collapse-title text-sm uppercase font-semibold">Parent Details</div>
        <div class="collapse-content border-t">
            <ul class="flex flex-col gap-2 mt-3">
                <li class="text-sm flex flex-col"><span class="font-semibold">Name :</span><span
                        class="text-zinc-500">{{profileData?.parent_details?.parent_name || '-'}}</span></li>
                <li class="text-sm flex flex-col"><span class="font-semibold">Email :</span><span
                        class="text-zinc-500">{{profileData?.parent_details?.email_id || '-'}}</span></li>
                <li class="text-sm flex flex-col"><span class="font-semibold">Mobile No.:</span><span
                        class="text-zinc-500">{{profileData?.parent_details?.mobile || '-'}}</span></li>
                <li class="text-sm flex flex-col"><span class="font-semibold">Relation with Student :</span><span
                        class="text-zinc-500">{{profileData?.parent_details?.relation_with_student || '-'}}</span></li>
                <li class="text-sm flex flex-col"><span class="font-semibold">Occupation Details :</span><span
                        class="text-zinc-500">{{profileData?.parent_details?.occupational_name || '-'}}</span></li>
            </ul>
        </div>
    </div>
    }
    @if (profileData?.address) {
    <!-- personal Details -->
    <div class="collapse collapse-arrow  border-b rounded-none">
        <input type="checkbox" />
        <div class="collapse-title text-sm uppercase font-semibold ">Address Details</div>
        <div class="collapse-content border-t">
            <ul class="flex flex-col gap-2 mt-3">
                <li class="text-sm flex flex-col">
                    <span class="font-semibold">Current Address :</span>
                    <span class="text-zinc-500">
                        {{getAddress('current')?.address || '-'}}
                        @if (getAddress('current')?.city || getAddress('current')?.district || getAddress('current')?.state) {
                        <span class="block">
                            {{getAddress('current')?.city || ''}}{{getAddress('current')?.city ? ' - ' : ''}}{{getAddress('current')?.district || ''}}
                        </span>
                        <span class="block">{{getAddress('current')?.state || ''}}{{getAddress('current')?.pincode ? ' - ' + getAddress('current')?.pincode : ''}}</span>
                        <span class="block">{{getAddress('current')?.country || ''}}</span>
                        }
                    </span>
                </li>
                <li class="text-sm flex flex-col">
                    <span class="font-semibold">Permanent Address :</span>
                    <span class="text-zinc-500">
                        {{getAddress('permanent')?.address || '-'}}
                        @if (getAddress('permanent')?.city || getAddress('permanent')?.district || getAddress('permanent')?.state) {
                        <span class="block">
                            {{getAddress('permanent')?.city || ''}}{{getAddress('permanent')?.city ? ' - ' : ''}}{{getAddress('permanent')?.district || ''}}
                        </span>
                        <span class="block">{{getAddress('permanent')?.state || ''}}{{getAddress('permanent')?.pincode ? ' - ' + getAddress('permanent')?.pincode : ''}}</span>
                        <span class="block">{{getAddress('permanent')?.country || ''}}</span>
                        }
                    </span>
                </li>
            </ul>
        </div>
    </div>
    <!-- personal Details -->
    }
    <!-- education Experience -->
    @if (profileData?.education || profileData?.education_text || profileData?.specialization) {
    <div class="collapse collapse-arrow border-b rounded-none">
        <input type="checkbox" />
        <div class="collapse-title text-sm uppercase font-semibold">Education Details</div>
        <div class="collapse-content border-t">
            <ul class="flex flex-col gap-2 mt-3">
                @if (profileData?.education?.length) {
                    @for (edu of profileData?.education || []; track $index) {
                        <li class="text-sm flex flex-col">
                            <span class="font-semibold">{{edu?.education_type || 'Education'}} :</span>
                            <span class="text-zinc-500">{{edu?.institute || '-'}}</span>
                            <span class="text-zinc-500 italic">{{edu?.degree || '-'}} {{edu?.year_of_degree ? '(' + edu?.year_of_degree + ')' : ''}}</span>
                        </li>
                    }
                }

                @if (!profileData?.education?.length && (profileData?.education_text || profileData?.specialization)) {
                    <li class="text-sm flex flex-col">
                        <span class="font-semibold">Education :</span>
                        <span class="text-zinc-500">{{profileData?.education_text || '-'}}</span>
                        <span class="text-zinc-500 italic">{{profileData?.specialization || ''}}</span>
                    </li>
                }
            </ul>
        </div>
    </div>
    <!-- education Experience -->
    }
    <!-- work Experience -->
    @if (profileData?.experience) {
    <div class="collapse collapse-arrow border-b rounded-none">
        <input type="checkbox" />
        <div class="collapse-title text-sm uppercase font-semibold">work experience Details</div>
        <div class="collapse-content border-t">
            <ul class="flex flex-col gap-2 mt-3">
                @for (exp of profileData?.experience || []; track $index) {
                <li class="text-sm flex flex-col">
                    <span class="font-semibold">{{exp?.position || 'Experience'}} </span>
                    <span class="text-zinc-500">{{exp?.institute || '-'}}</span>
                    <span class="text-zinc-500 italic">{{exp?.duration || '-'}}</span>
                </li>
                }

            </ul>
        </div>
    </div>
    <!-- work Experience -->
    }


</div>
<!-- profile card -->

@if (isModelOpen) {
@if (isStudent) {
<app-student-form-modal
    [isOpen]="isModelOpen"
    [studentId]="editRecordId"
    (closeModalemmit)="closeEditModal()"
></app-student-form-modal>
}@else {
<app-staff-common-form-modal
    [isOpen]="isModelOpen"
    [userId]="editRecordId"
    [userType]="editUserType"
    (closeModalemmit)="closeEditModal()"
></app-staff-common-form-modal>
}
}
